import React, { useState, useEffect, useRef } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import { Box } from "@mui/material";
import masterBanner from "../../assets/Frame 1000004677.png";

const AdCarousel = ({ ads = [] }) => {
  const [adImages, setAdImages] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);
  const intervalRef = useRef(null);

  // Get base URL for images
  const getBaseUrl = () => {
    if (process.env.NODE_ENV === 'development') {
      return 'https://backend.masterclick.in'; // Your development server
    }
    return 'https://backend.masterclick.in'; // Production - use relative URLs
  };

  // Create continuous carousel by duplicating ads
  const continuousAds = adImages.length > 1 ? [...adImages, ...adImages] : adImages;

  // Custom auto-play logic for one-directional rotation
  useEffect(() => {
    if (adImages.length > 1) {
      // Clear any existing interval
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }

      // Get the current image's time_shows value, default to 8000ms if not available
      const currentImage = adImages[currentSlide];
      const displayTime = currentImage?.time_shows || 8000;

      // Set up new interval for forward-only rotation
      intervalRef.current = setInterval(() => {
        setCurrentSlide((prev) => {
          const next = (prev + 1) % adImages.length;
          return next;
        });
      }, displayTime); // Use dynamic time from backend
    }

    // Cleanup on unmount or when adImages changes
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [adImages, currentSlide]);

  // Sync carousel with our custom state
  const handleSlideChange = (index) => {
    // If we reach the duplicated part, reset to original position
    if (index >= adImages.length && adImages.length > 0) {
      setCurrentSlide(index % adImages.length);
    } else {
      setCurrentSlide(index);
    }
  };

  useEffect(() => {
    console.log("=== ADS BACKEND RESPONSE DEBUG ===");
    console.log("Raw ads data from backend:", ads);
    console.log("Type of ads:", typeof ads);
    console.log("Ads length:", ads?.length);

    if (ads && ads.length > 0) {
      console.log("First ad structure:", ads[0]);
      console.log("Images in first ad:", ads[0]?.images);

      // Flatten all active images from all ad places, sorted by priority
      const allImages = ads
        .flatMap(adPlace => {
          console.log(`Processing ad place: ${adPlace.name}, images count: ${adPlace.images?.length}`);
          return adPlace.images
            .filter(img => img.is_active)
            .map(img => {
              let imageUrl = img.image;
              if (img.image.startsWith('http')) {
                imageUrl = img.image;
              } else {
                // Remove /api prefix if it exists in media paths
                const cleanPath = img.image.replace(/^\/api/, '');
                imageUrl = `${getBaseUrl()}${cleanPath}`;
              }
              console.log(`Image URL constructed: ${imageUrl}`);
              return {
                ...img,
                adPlaceName: adPlace.name,
                adPlaceId: adPlace.id,
                image: imageUrl
              };
            });
        })
        .sort((a, b) => a.priority_rank - b.priority_rank); // Sort by priority (lower number = higher priority)

      console.log("Final processed ad images:", allImages);
      setAdImages(allImages);
      setCurrentSlide(0); // Reset to first slide when ads change
    } else {
      console.log("No ads available");
      setAdImages([]);
      setCurrentSlide(0);
    }
    console.log("=== END ADS DEBUG ===");
  }, [ads]);

  // Get the current image's time_shows value for carousel interval
  const currentImage = adImages[currentSlide];
  const displayTime = currentImage?.time_shows || 8000;

  if (adImages.length === 0) {
    return (
      <Box sx={{
        width: "100%",
        height: { xs: "131px", sm: "160px", md: "255px", lg: "276px" },
        overflow: "hidden",
        borderRadius: { xs: "10px", sm: "0px" },
        backgroundColor: "#0d4f7a",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
      }}>
        <img
          src={masterBanner}
          alt="Master Click"
          style={{ width: "100%", height: "100%", objectFit: "contain", objectPosition: "center" }}
        />
        <Box
          className="slideshow-inner-shadow"
          sx={{ display: "block" }}
        />
      </Box>
    );
  }

  return (
    <Carousel
      showIndicators={false}
      showThumbs={false}
      showStatus={false}
      autoPlay={false}
      infiniteLoop={false}
      interval={displayTime}
      stopOnHover={false}
      swipeable={true}
      emulateTouch={true}
      dynamicHeight={false}
      showArrows={false}
      selectedItem={currentSlide}
      onChange={handleSlideChange}
      transitionTime={800}
      swipeScrollTolerance={5}
      preventMovementUntilSwipeScrollTolerance={true}
    >
      {continuousAds.map((ad, index) => (
        <Box
          key={`${ad.id}-${index}`}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: { xs: "131px", sm: "160px", md: "255px", lg: "276px" },
            cursor: "pointer",
            position: "relative",
            backgroundColor: "#fff",
            overflow: "hidden",
          }}
          onClick={() => {
            console.log("Ad clicked:", ad);
          }}
        >
          <img
            src={ad.image}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
              objectPosition: "center",
              transition: 'transform 0.5s ease',
              display: "block",
            }}
            loading="lazy"
            alt={ad.title || `Advertisement ${index + 1}`}
            onMouseEnter={(e) => e.target.style.transform = 'scale(1.02)'}
            onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
          />
          <Box
            className="slideshow-inner-shadow"
            sx={{ display: "block" }}
          />
        </Box>
      ))}
    </Carousel>
  );
};

export default React.memo(AdCarousel);
